<template>
  <div class="interest-over-time-graph" @mouseleave="onMouseLeave" @touchmove="detectOverArea">

    <transition name="selected-date" mode="out-in">
      <div :key="concept.id" class="selected-value" :style="selectedValueStyle">
        <div class="selected-value-internal">{{selectedValue}}</div>
      </div>
    </transition>

    <transition name="selected-date" mode="out-in">
      <div :key="concept.id" class="selected-date" :style="selectedDateStyle">
        <div class="selected-date-internal">{{selectedDate}}</div>
      </div>
    </transition>

    <div class="graph-container">

      <svg class="graph" width='100%' height='100%' viewBox="0 0 100 100" preserveAspectRatio="none">
        <transition mode="out-in" name="line">
          <polyline :key="concept.id" class="graph-line" vector-effect="non-scaling-stroke" :points="graphPoints" :style="{stroke: '#' + concept.categoryObject.color.toString(16)}" />
        </transition>
      </svg>

      <transition-group tag="div" class="years-container">
        <div
          class="year-separator"
          v-for="(year, index) in years"
          :style="getYearStyle(year)"
          :key="year.label"
          >
          <span>{{year.label}}</span>
        </div>
      </transition-group>

      <div
        class="over-area"
        v-for="(activity, index) in concept.interestOverTime"
        :style="getOverAreaStyle(index)"
        :data-over-index="index"
        @mouseenter="onOverAreaMouseEnter(index)"
        @touchstart="onOverAreaMouseEnter(index)"
        />

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import find from 'lodash/find'

export default {
  name: 'InterestOverTimeGraph',
  props: {
    concept: {
      type: Object,
      required: true
    },
    selectedIndex: {
      type: Number
    }
  },

  data: function () {
    return {

    }
  },

  methods: {
    detectOverArea: function (event) {
      let element = document.elementFromPoint(event.touches[0].clientX, event.touches[0].clientY)
      if (element && element.dataset) {
        let dataset = JSON.parse(JSON.stringify(element.dataset))
        if (dataset['overIndex']) {
          this.onOverAreaMouseEnter(parseInt(dataset['overIndex']))
        }
      }
    },
    onMouseLeave: function () {
      this.$emit('update:selectedIndex', -1)
    },
    onOverAreaMouseEnter: function (index) {
      this.$emit('update:selectedIndex', index)
    },
    getOverAreaStyle: function (index) {
      let l = this.concept.interestOverTime.length
      let w = (100 / l)

      let backgroundColor
      // let pointerEvents

      if (index === this.selectedIndex) {
        backgroundColor = '#' + this.concept.categoryObject.color.toString(16)
        // pointerEvents = 'none'
      }

      return {
        width: w + '%',
        left: (w * index) + '%',
        backgroundColor
        // pointerEvents
      }
    },
    getYearStyle: function (year) {
      let l = this.concept.interestOverTime.length
      let w = (100 / l)
      let index = year.dataIndex
      return {
        left: ((w / 2) + (w * index)) + '%'
      }
    }
  },

  computed: {
    selectedDateStyle: function () {
      let index = this.selectedIndex === -1 ? this.concept.interestOverTime.length - 1 : this.selectedIndex
      let l = this.concept.interestOverTime.length
      let w = (100 / l)
      let x = ((w / 2) + (w * index))

      let margin = 3
      x = Math.min(100 - margin, Math.max(margin, x))

      return {
        left: x + '%'
      }
    },
    selectedValueStyle: function () {
      let index = this.selectedIndex === -1 ? this.concept.interestOverTime.length - 1 : this.selectedIndex
      let l = this.concept.interestOverTime.length
      let w = (100 / l)
      let x = ((w / 2) + (w * index))

      let margin = 1
      x = Math.min(100 - margin, Math.max(margin, x))

      return {
        left: x + '%',
        color: '#' + this.concept.categoryObject.color.toString(16)
      }
    },
    graphPoints: function () {
      let ret = ''
      let l = this.concept.interestOverTime.length
      let w = (100 / l)
      for (let i = 0; i < this.concept.interestOverTime.length; i++) {
        let x = ((w / 2) + (w * i))
        let y = (100 - (this.concept.interestOverTime[i].interest * 100))
        y = 2 + (y * 0.96)
        ret += x + ',' + y + ' '
      }
      return ret
    },
    years: function () {
      let r = []
      for (let i = 0; i < this.concept.interestOverTime.length; i++) {
        let entry = this.concept.interestOverTime[i]
        let year = moment(entry.date).year()
        if (!find(r, {label: year})) {
          r.push({
            label: year,
            dataIndex: i
          })
        }
      }
      // push last one
      r.push({
        label: moment(this.concept.interestOverTime[this.concept.interestOverTime.length - 1].date).year(),
        dataIndex: this.concept.interestOverTime.length - 1
      })
      return r
    },
    selectedDate: function () {
      let year

      if (this.selectedIndex !== -1) {
        year = moment(this.concept.interestOverTime[this.selectedIndex].date).year()
      } else {
        year = moment(this.concept.interestOverTime[this.concept.interestOverTime.length - 1].date).year()
      }

      if (year === moment().year()) {
        if (this.selectedIndex !== -1) {
          return moment(this.concept.interestOverTime[this.selectedIndex].date).format('DD MMM')
        }

        return moment(this.concept.interestOverTime[this.concept.interestOverTime.length - 1].date).format('DD MMM')
      } else {
        if (this.selectedIndex !== -1) {
          return moment(this.concept.interestOverTime[this.selectedIndex].date).format('DD MMM YYYY')
        }

        return moment(this.concept.interestOverTime[this.concept.interestOverTime.length - 1].date).format('DD MMM YYYY')
      }
    },
    selectedValue: function () {
      if (this.selectedIndex !== -1) {
        return Math.round(this.concept.interestOverTime[this.selectedIndex].interest * 100)
      }
      return Math.round(this.concept.interestOverTime[this.concept.interestOverTime.length - 1].interest * 100)
    }
  },

  watch: {

  }
}
</script>

<style scoped lang="scss">
@import 'variables';




$transition-length: 0.3s;

.interest-over-time-graph {
  position: relative;
  // margin: 10px 0;
  box-sizing: border-box;
  margin-top: 60px;
}

.over-area {
  position: absolute;
  top: 0;
  height: 100%;
  opacity: 0.3;
}

.graph-line {
  fill: none;
  stroke-width: 2;
  transition: stroke 0.3s $ease-in-out-quad;
  transform-origin: 50% 100%;
}

.selected-date,
.selected-value {
  position: absolute;
  text-align: center;
  display: block;
  white-space: nowrap;
  width: 0;
  height: 0;
}

.selected-value {
  top: -25px;
}
.selected-date {
  bottom: 0;
}
.selected-date-internal,
.selected-value-internal {
  position: absolute;
  top: 0;
  left: 50%;
  font-weight: 600;
  transform: translate(-50%, 0);
}

.selected-date-internal {
  color: #808184;
}

.selected-value {
  font-size: 20px;
}
.selected-date {
  font-size: 12px;
}

.graph-container {
  position: relative;
  height: 82%;
  // margin-top: 5px;
  border-bottom: 1px solid $c-silver;
}

.years-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.year-separator {
  position: absolute;
  top: 0;
  width: 0;
  height: 100%;
  font-size: 12px;
  color: $c-silver;
  border-left: 1px dashed $c-silver;
  pointer-events: none;
  transition: opacity $transition-length $ease-in-out-quad, left $transition-length $ease-in-out-quad;

  span {
    position: absolute;
    bottom: -5px;
    left: 0;
    transform: translate(-50%, 100%);
  }
}

.line-enter-active {
  transition: all #{$transition-length} $ease-out-quad;
}
.line-leave-active {
  transition: all #{$transition-length} $ease-in-quad;
}

.line-enter,
.line-leave-to {
  transform: scale3d(1, 0.01, 1);
  opacity: 0;
}

.selected-date-enter-active,
.selected-date-leave-active {
  transition: opacity $transition-length $ease-in-out-quad, transform $transition-length $ease-in-out-quad;
  // position: relative;
}

.selected-date-enter {
  opacity: 0;
  // transform: translate(0, -30px);
}
.selected-date-leave-to {
  opacity: 0;
  // transform: translate(0, 30px);
}

</style>



// WEBPACK FOOTER //
// src/molecules/InterestOverTimeGraph.vue